import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  result: string;
  avatar: string;
}
const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote,
  name,
  result,
  avatar
}) => {
  return <div className="relative bg-navy border-l-[3px] border-gold rounded-lg p-6 shadow-lg h-full flex flex-col" style={{
    borderLeftColor: '#D4AF37',
    backgroundColor: '#0A1628'
  }} data-id="element-147">
      <Quote className="text-gold mb-4" size={36} fill="#D4AF37" fillOpacity={0.15} data-id="element-148" />
      <p className="text-lg text-white leading-relaxed mb-6 flex-1" data-id="element-149">
        "{quote}"
      </p>
      <div className="flex items-center gap-4 mt-auto pt-4 border-t border-gold/20" data-id="element-150">
        <div className="shrink-0 w-14 h-14 rounded-full border-2 border-gold overflow-hidden" data-id="element-151">
          <img src={avatar} alt={name} className="w-full h-full object-cover" data-id="element-152" />
        </div>
        <div className="flex-1" data-id="element-153">
          <p className="text-gold text-base font-medium" data-id="element-154">{name}</p>
          <p className="text-gold font-bold text-base" data-id="element-155">{result}</p>
        </div>
      </div>
    </div>;
};
export const Testimonials: React.FC = () => {
  return <SectionWrapper data-id="element-156">
      <h2 className="text-3xl md:text-4xl font-bold text-gold mb-12 text-center" data-id="element-157">
        Lo Que Dicen Quienes Ya Lo Usaron
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-158">
        <TestimonialCard quote="Tenía mi cita en 3 días y estaba paralizado del miedo. Leí el protocolo la noche anterior, practiqué las 7 respuestas frente al espejo y entré a la embajada con un plan claro. La entrevista duró menos de 4 minutos. Salí con mi visa aprobada." name="— Carlos M., México" result="✅ Visa B1/B2 Aprobada" avatar="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&auto=format&fit=crop&q=80" data-id="element-159" />
        <TestimonialCard quote="Ya me habían negado la visa una vez. Esta vez llegué con el Método MRA preparado. El oficial me hizo 5 preguntas y yo respondí cada una en menos de 10 palabras. No hubo repreguntas. No hubo dudas. Salí con mi visa ese mismo día." name="— Valentina R., Colombia" result="✅ Visa B1/B2 Aprobada" avatar="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&auto=format&fit=crop&q=80" data-id="element-160" />
      </div>
    </SectionWrapper>;
};